import { Link } from "react-router-dom";
import { Card, ListGroup, ListGroupItem } from "react-bootstrap";

const samples = [
    '110.DEC',
    '42295.DEC',
    '524.DEC',
    '5678.DEC',
    '72x48-LShapWithCutouts.DEC',
    '72x48-WrapWithCutouts.DEC',
    'Mestek Viewer Test.DEC',
    'Sheets.DEC',
    'SingleSided-NoCutouts.DEC',
    'VarietyPack.DEC',
    'WrapAndSingleWithCutouts.DEC',
];

export default function DownloadsList() {
    return (
        <Card>
            <Card.Body>
                <Card.Title>Downloads</Card.Title>
            </Card.Body>
            <ListGroup className="list-group-flush">
                {samples.map((s, i) => (
                    <ListGroupItem key={i}><Link to={`/downloads/samples/${s}`}>{s}</Link></ListGroupItem>
                ))}
            </ListGroup>
            <Card.Body>
                <Link
                    className="btn btn-primary btn-sm"
                    role="button"
                    to="/downloads"
                >
                    Import New Download
                </Link>
            </Card.Body>
        </Card>
    );
}
